import Typography from '@material-ui/core/Typography';
import { FC, ReactElement } from 'react';

import { ITeamMemberMapped } from '~/utils/clientAllocation';

import useClientAllocationsUpdate from '../../hooks/updateAllocations/useClientAllocationsUpdate';
import { IEditAllocationFormValues } from '../../../shared/model/types';
import AllocationClientsSelect from '../SelectFields/AllocationClientsSelect';
import useAllocationChangeTracking from '../../../shared/hooks/useAllocationChangeTracking';
import AllocationClientRowItem from '../ClientsRowItem/AllocationClientRowItem';
import layoutStyles from '../../../shared/components/EditAllocationFormLayout/EditAllocationFormLayout.module.scss';

interface IProps {
  teamMemberIdx: number;
  teamMember: ITeamMemberMapped;
}

const AllocationClientsList: FC<IProps> = ({ teamMemberIdx, teamMember }): ReactElement => {
  const { markChanged, markDeleted } = useAllocationChangeTracking<IEditAllocationFormValues>({
    changedField: 'changedAllocationsIds',
    deletedField: 'deletedAllocationsIds',
  });
  const {
    fields: clientsAllocationsFields,
    updateAllocations,
    removeClientAt,
  } = useClientAllocationsUpdate(teamMemberIdx);

  return (
    <>
      <Typography variant="subtitle1" className={layoutStyles.assignedClientsSectionTitle}>
        Client Allocations
      </Typography>

      <AllocationClientsSelect
        teamMemberIdx={teamMemberIdx}
        teamMember={teamMember}
        updateAllocations={updateAllocations}
      />

      {clientsAllocationsFields.map((field, clientIdx) => (
        <AllocationClientRowItem
          key={field.id}
          field={field}
          clientIdx={clientIdx}
          teamMemberIdx={teamMemberIdx}
          memberId={teamMember.id}
          fieldsCount={clientsAllocationsFields.length}
          onMarkChanged={markChanged}
          onMarkDeleted={markDeleted}
          onRemove={removeClientAt}
        />
      ))}
    </>
  );
};

export default AllocationClientsList;
